import { CSSProperties, FC, useRef, useState } from 'react'
import { ProductCard } from './components/ProductCard/ProductCard'

type TProps = {
  products: Data.Product[]
  style: CSSProperties
}

const ProductsPage: FC<TProps> = ({ products, style }) => {
  return (
    <div className="grid grid-cols-4 gap-12 grid-rows-2" style={style}>
      {products.map((item, index) => (
        <ProductCard key={index} data={item} />
      ))}
    </div>
  )
}

export { ProductsPage }
